// This file was auto-generated by __GENERATE_CHAIN_PRESETS__.js. Do not edit manually.

import { astar as _astar } from 'viem/chains'
import { createCommon } from '../createCommon.js'

/**
 * Creates a common configuration for the astar chain.
 * @type {import('../Common.js').Common}
 * @description
 * Chain ID: 592
 * Chain Name: Astar
 * Default Block Explorer: https://astar.subscan.io
 * Default RPC URL: https://astar.api.onfinality.io/public
 * @example
 * import { createMemoryClient } from 'tevm'
 * import { astar } from 'tevm/common'
 * import { http } from 'tevm'
 *
 * const client = createMemoryClient({
 *   common: astar,
 *   fork: {
 *     transport: http({ url: 'https://example.com' })({})
 *   },
 * })
 */
export const astar = createCommon({
	..._astar,
	loggingLevel: 'warn',
	eips: [],
	hardfork: 'prague',
})
